import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactUsPageComponent } from './contact-us-page/contact-us.component';

import { LandingPageComponent } from './landing-page/landing-page.component';
import { MainServicesComponent } from './services-page/main-services.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
  },
  {
    path: 'main',
    component: LandingPageComponent,
  },
  {
    path: 'services',
    component: MainServicesComponent,
  },
  {
    path: 'contact-us',
    component: ContactUsPageComponent,
  },
  {
    path: '**',
    component: LandingPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
